var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIcCheckYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.69.202C27.336-.522 25.826.873 24.94 1.7c-2.03 1.965-3.749 4.239-5.675 6.306-2.135 2.275-4.114 4.549-6.3 6.772-1.25 1.24-2.604 2.584-3.437 4.135-1.874-1.81-3.488-3.774-5.571-5.376-1.51-1.137-4.01-1.964-3.957.775.104 3.567 3.28 7.392 5.623 9.821.99 1.034 2.291 2.12 3.801 2.171 1.822.104 3.697-2.067 4.79-3.256 1.927-2.068 3.489-4.394 5.259-6.513 2.291-2.791 4.634-5.53 6.873-8.374 1.406-1.757 5.831-6.099 2.343-7.96zM2.292 14.106c-.052 0-.104 0-.209.051a2.546 2.546 0 0 1-.572-.206c.156-.104.416-.052.78.155z",
    fill: "#F9BE00",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcCheckYellow);
export default __webpack_public_path__ + "static/media/icon-ic-check-yellow.a8742c854feca3b6934f21d7162cf6a8.svg";
export { ForwardRef as ReactComponent };